module.exports = __webpack_public_path__ + "img/edit.d429b64a.png";